import { object, string } from 'yup';

export type TThankYouForm = {
  message: string;
};

export const validationSchema = object().shape({
  message: string().trim().required().max(1000),
});
